export function setState(state, [field, value]) {
  state[field] = value;
}

export function setQuote(state, quote) {
  state.quote = quote;
}

export function setQuotePDFHref(state, href) {
  state.quotePDFHref = href;
}

export function setVariant(state, variant) {
  state.quote.variant = variant;
}

export function setDealersPrice(state, price) {
  state.dealersPrice = price;
}

export function setPrice(state, price) {
  state.quote.price.listPriceNet = price;
  state.quote.price.fbtBaseValue = price;
}

export function setColoursAndExtras(state, coloursAndExtras) {
  state.coloursAndExtras = { ...coloursAndExtras };
}

export function openAcceptanceDialog(state) {
  state.privacyDocumentOpenedDate = undefined;
  state.privacyDocumentAcceptedDate = undefined;
  state.termsDocumentOpenedDate = undefined;
  state.termsDocumentAcceptedDate = undefined;
  state.leaseDocumentOpenedDate = undefined;
  state.leaseDocumentAcceptedDate = undefined;
  state.displayQuoteAcceptance = true;
}

export function setRouteQuoteId(state, quoteId) {
  state.routeQuoteId = quoteId;
}
